const VERSION_KEY = 'ml_app_version';

export function getCurrentVersion() {
  return import.meta.env.VITE_APP_VERSION || 'dev';
}

export function getStoredVersion() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(VERSION_KEY);
}

export function setStoredVersion(version) {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(VERSION_KEY, version);
}

export function isNewVersionAvailable() {
  const current = getCurrentVersion();
  const stored = getStoredVersion();
  return Boolean(stored && stored !== current);
}

export function isUpdatePending() {
  return Boolean(typeof window !== 'undefined' && window.__ML_UPDATE_PENDING__ === true);
}

export function setUpdatePending(value) {
  if (typeof window === 'undefined') return;
  window.__ML_UPDATE_PENDING__ = Boolean(value);
}
